import React from "react";
import TabLayout from "../../components/TabLayout";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Truck from "../trucks/Truck";
import HotelConfiguration from "../hotel/HotelConfiguration";
import RestaurantConfiguration from "../Restaurant/RestaurantConfiguration";

export default function BarcodeConfigurationTab(props) {
    return (
        <Grid container spacing={0.5}>
            <Grid item xs={12}><Typography variant="h5">Barcode Configuration</Typography></Grid>
            <Grid item xs={12}><Divider/></Grid>
            <Grid item xs={12}>
                <TabLayout
                    tabs={[
                        {title: "Tour Operator", component: <Truck/>},
                        {title: "Hotel", component: <HotelConfiguration/>},
                        {title: "Restaurant", component: <RestaurantConfiguration/>},
                    ]}
                />
            </Grid>
        </Grid>
    );
}